import { parseAmount } from "@/lib/misc/parseAmount";
import { RootState } from "@/lib/redux/types";
import { Amount } from "@evergiving/common/dist/es2015/pledge";

// FIXME: this will trigger too many re-renders for custom amounts because of
// equality
export const amountSelector = (state: RootState): Amount => {
  if (state.presetAmount) {
    return state.presetAmount;
  }
  if (state.customCurrency && state.customAmountString.value) {
    const value = parseAmount(state.customAmountString.value);
    if (typeof value !== "undefined") {
      return {
        currency: state.customCurrency,
        value,
      };
    }
  }
  return { currency: "XXX", value: 0 };
};
